import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant63() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас ',
      titleFree: 'бесплатно.',
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      priceLabel: '✅ Оплата только за результат',
      cta: 'Получить макет'
    },
    ua: {
      title1: 'Зробимо сайт для вас ',
      titleFree: 'безкоштовно.',
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      priceLabel: '✅ Оплата лише за результат',
      cta: 'Отримати макет'
    },
    en: {
      title1: 'We build your website ',
      titleFree: 'for free.',
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      priceLabel: '✅ Pay only for results',
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden px-4 pt-24 md:pt-28 pb-12 md:pb-16 flex flex-col justify-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-928">
        <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-929">
          <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] rounded-full blur-[100px]" style={{
          background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)'
        }} data-id="element-930" />
        </div>

        <div className="relative z-20 mx-auto flex w-full max-w-6xl flex-col md:flex-row items-center justify-center gap-8 md:gap-12 mt-0 md:mt-8 lg:mt-0" data-id="element-931">
          <div className="w-full md:flex-1 text-center md:text-left" data-id="element-932">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="mb-6 md:mb-8 text-4xl leading-tight tracking-tight md:text-5xl lg:text-[4rem] font-bold text-gray-900" data-id="element-933">
              {content.title1}
              <span className="text-blue-600" data-id="element-934">{content.titleFree}</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="text-lg md:text-xl mb-10 font-medium max-w-lg mx-auto md:mx-0 leading-relaxed text-gray-600" data-id="element-935">
              {content.sub}
            </motion.p>

            {/* Price Block - Desktop */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="hidden md:flex w-max flex-row items-center gap-8 bg-white rounded-[2rem] p-3 pr-3 pl-8 shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100" data-id="element-936">
              <div className="flex flex-col items-start py-0" data-id="element-937">
                <span className="text-sm font-semibold mb-1 flex items-center gap-1.5 text-green-600" data-id="element-938">
                  {content.priceLabel}
                </span>
                <div className="flex items-baseline gap-2" data-id="element-939">
                  <span className="text-4xl font-bold text-gray-900" data-id="element-940">
                    {price}
                  </span>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-md" data-id="element-941">
                    в месяц
                  </span>
                </div>
              </div>

              <button onClick={() => setIsPopupOpen(true)} className="bg-[#3B82F6] text-white px-8 py-5 rounded-2xl font-bold text-lg hover:bg-blue-600 transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-942">
                {content.cta} <ArrowRightIcon className="w-5 h-5" data-id="element-943" />
              </button>
            </motion.div>

            {/* Price Block - Mobile */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="flex md:hidden flex-col w-full bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden p-5 sm:p-6 gap-6" data-id="element-944">
              <div className="flex flex-col items-center text-center" data-id="element-945">
                <span className="text-sm font-semibold mb-2 flex items-center gap-1.5 text-green-600" data-id="element-946">
                  {content.priceLabel}
                </span>
                <div className="flex items-baseline gap-2 mb-6" data-id="element-947">
                  <span className="text-5xl font-bold text-gray-900" data-id="element-948">
                    {price}
                  </span>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-md" data-id="element-949">
                    в месяц
                  </span>
                </div>
                <button onClick={() => setIsPopupOpen(true)} className="w-full bg-[#3B82F6] text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-blue-600 transition-all shadow-md flex items-center justify-center gap-2" data-id="element-950">
                  {content.cta} <ArrowRightIcon className="w-5 h-5" data-id="element-951" />
                </button>
              </div>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="w-full md:flex-1 relative mt-8 md:mt-0 flex items-center justify-center" data-id="element-952">
            <div className="relative w-full max-w-[480px] mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-200 bg-white" data-id="element-953">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-954" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-955" />
    </>;
}